import { render, staticRenderFns } from "./AirportsList.vue?vue&type=template&id=4a7e42e5"
import script from "./AirportsList.vue?vue&type=script&lang=js"
export * from "./AirportsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports